import { render } from "./UserDetailModal.vue?vue&type=template&id=85a36a40&ts=true"
import script from "./UserDetailModal.vue?vue&type=script&lang=ts"
export * from "./UserDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__